import { isMaintenanceModeWebEnabled } from '~/utils/maintenance/maintenance';

export default function ({ redirect }) {
  if (isMaintenanceModeWebEnabled()) {
    return;
  }
  redirect('/login/');
}
